import ScrollDown from "@/assets/icons/ScrollDown";
import { FC } from "react";
import { useTranslation } from "react-i18next";

export const ScrollIndicator: FC<{ href: string; mode: "light" | "dark" }> = ({ href, mode }) => {
  const { t } = useTranslation();
  return (
    <a
      href={href}
      className={`relative z-50 my-4 flex min-h-11 min-w-36 flex-col items-center justify-center self-center sm:flex-row sm:items-start sm:self-auto ${
        mode === "dark" ? "text-black" : "text-white"
      }`}
    >
      <span className="mb-8 sm:mb-0">{t("scrollDown")}</span>
      <div className="arrow-container">
        <div className={`arrow-head ${mode}`}>
          <ScrollDown />
        </div>
        <div className={`arrow-line ${mode}`}></div>
      </div>
    </a>
  );
};
